import { defineFinderKind } from "./define-finder-kind";

export default defineFinderKind({ name: "events" });
